import { useBrand } from '@/features/branding/brand-provider';
import CodeForm from '@/features/student/components/code-form';
import { LoginLayout } from '@/routes/trainee/login-layout';

export function CodeLogin() {
  const { brand } = useBrand();
  return (
    <LoginLayout>
      <CodeForm site={brand} />
    </LoginLayout>
  );
}
